import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Button, Header, Image } from '../../models';

@Component({
    selector: 'app-header-article',
    templateUrl: './header-article.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HeaderArticleComponent {
  @Input() subtitle?: string;
  @Input() title?: string;
  @Input() intro?: string;
  @Input() image?: Image;
  @Input() button?: Button;

  constructor() {}
}
